module.exports = __webpack_public_path__ + "static/media/rc-pollution-icon.a820f343.svg";